import { Input,Form,Button, message } from "antd"
import { useGlobalContext } from "../../context/provider"
import { AxiosPostData } from "../../context/axiosfunction"

const Regis = () => { 
    const {setTypeLogin,API,privateKey} = useGlobalContext()
    const [FormRegis] = Form.useForm()

    const SendData = async(data) => {
        if(data.password !== data.Repassword){
            return message.open({
                type:'error',
                content:'รหัสผ่านไม่ตรงกัน'
            })
        }
        
        try {
            const Regis = await AxiosPostData(API,'/api/register',data,privateKey)
            if(Regis.status==='success'){
                message.open({
                    type:'success',
                    content:Regis.message
                })
                FormRegis.resetFields()
            }else{
                message.open({
                    type:'error',
                    content:Regis.message
                })
            }
            
        } catch (error) {
             message.open({
                type:'error',
                content:'เกิดข้อผิดพลาดกรุณารอการแก้ไข'
            })
        }
    }
    
    return(
        <div className="flex page-bg flex-col items-center gap-[16px] pt-[30px] h-full text-primary">
            <p className="text-[30px] font-normal">ลงทะเบียน</p>
            <Form onFinish={SendData} autoComplete="off" form={FormRegis} className="w-[60%] flex flex-col gap-[25px]">
                <Form.Item name="username"  layout="vertical" 
                    label={<span className="text-[16px] text-primary"  >ชื่อผู้ใช้</span> }  
                    className="flex flex-col h-[40px]" 
                    rules={[{required: true,message: 'กรุณาระบุชื่อผู้ใช้',}]}
                >
                    <Input placeholder="กรุณาระบุชื่อผู้ใช้" className="rounded-full h-[40px] " />
                </Form.Item>
                <Form.Item name="email" rules={[
                    {
                        type: 'email',
                        message: 'กรุณากรอกรูปแบบเมลที่ถูกต้อง',
                    },
                    {
                        required: true,
                        message: 'กรุณาระบุอีเมล',
                    },
                    ]} layout="vertical" 
                    label={<span className="text-[16px] text-primary"  >อีเมล</span> }  className="flex flex-col  h-[40px]"
                >
                    <Input placeholder="example@gmail.com" className="rounded-full h-[40px]" />
                </Form.Item>
                <Form.Item name="password" layout="vertical" 
                    label={<span className="text-[16px] text-primary">รหัสผ่าน</span> } 
                    className="flex flex-col  h-[40px]"
                    rules={[{required: true,message: 'กรุณาระบุรหัสผ่าน',}]}
                >
                    <Input.Password placeholder="************" className="rounded-full h-[40px]"  type="password" />
                </Form.Item>
                <Form.Item name="Repassword" layout="vertical" 
                    label={<span className="text-[16px] text-primary">ยืนยันรหัสผ่าน</span> }  
                    className="flex flex-col  h-[40px]"
                    rules={[{required: true,message: 'กรุณายืนยันรหัสผ่าน',}]}
                >
                    <Input.Password placeholder="************" className="rounded-full h-[40px]"  type="password" />
                </Form.Item>
                <Form.Item  className="mt-[24px]  mb-0">
                    <Button htmlType="submit" style={{borderRadius:'40px'}}  className="w-full  h-[40px] btn-primary">ลงทะเบียน</Button>
                </Form.Item>
            </Form>
            <div style={{fontFamily:'Noto Sans Thai',color:'#C4C4C4'}}>หรือ</div>
            <div className="flex gap-[24px]">
                <button type="button">
                    <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_line.png" alt="line" />
                </button>
                <button type="button">
                    <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_gg.png" alt="gg" />
                </button>
                <button type="button">
                    <img className="h-[32px]" src="https://eve-image.eveebook.com/image.eveebook/web_image/new_fb.png" alt="fb" />
                </button>
            </div>
            <div className="flex justify-between items-end h-full w-[60%] pb-[46px]">
                <span className="text-disable">ฉันเป็นสมาชิกอยู่แล้ว?</span>
                <button onClick={()=>setTypeLogin('login')} type="button" className="text-special cursor-pointer">เข้าสู่ระบบ</button>
            </div>
        </div>
    )
}

export default Regis